import './OnboardingFinal.scss';
import React from 'react';
import { Button } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { useClientPersistedState } from '../persistedstate/clients/useClientPersistedState';
import { useAppSelector } from '../hooks/ReduxHooks';
import { InlineWidget } from 'react-calendly';
import { StepOneIcon, StepThreeIcon, StepTwoIcon } from './icons';
import { canIUse, Features } from '../helpers/PermissionUtility';

export default function OnboardingFinal() {
  const navigate = useNavigate();
  const [signupDomain] = useClientPersistedState('signupDomain');
  const companySize = useAppSelector<string>((state) => state.profile.client?.companySize);
  const blockedDomains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'icloud.com', 'privaterelay.appleid.com', 'google.com'];
  const showCalendly = !blockedDomains.includes(signupDomain) && (companySize === '1,000 - 9,999' || companySize === '10,000+');

  return (
    <div className="container">
      <div className="left-side">
        <div className="left-side-content">
          <h1>Your free 14-day trial of the Advanced subscription is now active. With your trial, you can:</h1>
          <ul>
            <li>Build unlimited Templates</li>
            <li>Securely collect forms from anyone</li>
            <li>Automate your processes with Workflows</li>
            <li>Report on the data you collect</li>
          </ul>
          <Button primary onClick={() => navigate('/', { replace: true })}>
            Explore my account
          </Button>
          <p className="small-text">If you don't subscribe during your trial period, you'll switch to a free Basic plan.</p>
        </div>
      </div>
      <div className="right-side">
        {canIUse(Features.ShowCalendlyDuringSurvey) && showCalendly ? (
          <div className="right-side-content-calendly">
            <InlineWidget
              url="https://calendly.com/dcrozier-23/custom-onboarding"
              styles={{
                height: '900px'
              }}
            />
          </div>
        ) : (
          <div className="right-side-content">
            <h1>Start collecting Forms in just three steps:</h1>
            <div className="bullets">
              <div className="grid-container">
                <div className="grid-item">
                  <StepOneIcon />
                  <StepTwoIcon />
                  <StepThreeIcon />
                </div>
                <div className="grid-item">
                  <span>Upload your PDF (or start from scratch)</span>
                  <span>Add fields to your Template</span>
                  <span>Use your Template to fill out Forms</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
